import { OrderSystem } from '@cbgms/api/modules/enums'

export enum OrderSystemFeature {
  RouteDepartureCountdown = 'RouteDepartureCountdown'
}

const FEATURE_ORDER_SYSTEMS: Record<OrderSystemFeature, ReadonlyArray<OrderSystem>> = {
  [OrderSystemFeature.RouteDepartureCountdown]: [OrderSystem.VPOM_AxNl, OrderSystem.VPOM_AxFr]
}

export const isFeatureApplicable = (feature: OrderSystemFeature, orderSystem?: OrderSystem | string | null): boolean =>
  FEATURE_ORDER_SYSTEMS[feature]?.includes(orderSystem as OrderSystem) ?? false
